function findPanel(root, id) {
    if (!id) return null;

    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        return root.querySelector(`#${CSS.escape(id)}`);
    }

    return Array.from(root.querySelectorAll('[id]')).find((element) => element.id === id) || null;
}

function initDialogs(root) {
    const dialogs = root.querySelectorAll('[data-operations-dialog]');

    dialogs.forEach((dialog) => {
        if (typeof HTMLDialogElement === 'undefined' || !(dialog instanceof HTMLDialogElement)) return;

        let trigger = null;
        const close = () => {
            if (dialog.open) dialog.close();
        };

        root.querySelectorAll('[data-operations-dialog-open]').forEach((button) => {
            if (button.dataset.operationsDialogOpen !== dialog.id) return;

            button.addEventListener('click', () => {
                trigger = button;
                if (!dialog.open) dialog.showModal();
            });
        });

        dialog.querySelectorAll('[data-operations-dialog-close]').forEach((button) => {
            button.addEventListener('click', close);
        });

        dialog.addEventListener('click', (event) => {
            if (event.target === dialog) close();
        });

        dialog.addEventListener('close', () => {
            if (trigger instanceof HTMLElement) trigger.focus();
            trigger = null;
        });
    });
}

function initTabs(root) {
    root.querySelectorAll('[data-operations-tabs]').forEach((tabList) => {
        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        if (tabs.length === 0) return;

        const selectTab = (selectedTab) => {
            tabs.forEach((tab) => {
                const selected = tab === selectedTab;
                const panelId = tab.getAttribute('aria-controls');
                const panel = findPanel(root, panelId);

                tab.setAttribute('aria-selected', String(selected));
                tab.tabIndex = selected ? 0 : -1;
                if (panel) panel.hidden = !selected;
            });
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => selectTab(tab));
            tab.addEventListener('keydown', (event) => {
                const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
                if (!keys.includes(event.key)) return;

                event.preventDefault();
                let nextIndex = index;
                if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
                if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
                if (event.key === 'Home') nextIndex = 0;
                if (event.key === 'End') nextIndex = tabs.length - 1;

                tabs[nextIndex].focus();
                selectTab(tabs[nextIndex]);
            });
        });

        const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
        selectTab(selected);
    });
}

function initDisclosure(root) {
    root.querySelectorAll('[data-operations-disclosure-button]').forEach((button) => {
        const panelId = button.getAttribute('aria-controls');
        const panel = findPanel(root, panelId);
        if (!panel) return;

        const setExpanded = (expanded) => {
            button.setAttribute('aria-expanded', String(expanded));
            panel.hidden = !expanded;
        };

        button.addEventListener('click', () => {
            setExpanded(button.getAttribute('aria-expanded') !== 'true');
        });

        setExpanded(button.getAttribute('aria-expanded') === 'true');
    });
}

function initOperationsNavigation() {
    const toggle = document.querySelector('[data-operations-nav-toggle]');
    const menuId = toggle?.getAttribute('aria-controls');
    const menu = menuId ? document.getElementById(menuId) : null;
    if (!(toggle instanceof HTMLButtonElement) || !(menu instanceof HTMLElement)) return;

    const mobileQuery = window.matchMedia?.('(max-width: 767px)');
    const sync = (isOpen = false, restoreFocus = false) => {
        const isMobile = mobileQuery?.matches ?? false;
        if (!isMobile) {
            menu.removeAttribute('aria-hidden');
            toggle.setAttribute('aria-expanded', 'false');
            return;
        }

        menu.setAttribute('aria-hidden', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(isOpen));
        if (!isOpen && restoreFocus) toggle.focus();
    };

    toggle.addEventListener('click', () => sync(toggle.getAttribute('aria-expanded') !== 'true'));
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;
        event.preventDefault();
        sync(false, true);
    });
    mobileQuery?.addEventListener?.('change', () => sync(false));
    menu.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', () => sync(false)));
    sync(false);
}

function initStaticForms(root) {
    root.querySelectorAll('[data-static-form]').forEach((form) => {
        if (!(form instanceof HTMLFormElement)) return;

        form.addEventListener('submit', (event) => {
            event.preventDefault();

            let status = form.querySelector('[data-static-form-status]');
            if (!(status instanceof HTMLElement)) {
                status = document.createElement('p');
                status.className = 'operations-admin__notice operations-admin__notice--warning';
                status.dataset.staticFormStatus = '';
                status.setAttribute('role', 'status');
                form.prepend(status);
            }

            status.textContent = 'この機能は準備中のため、操作内容は保存されません。';
        });
    });
}

export function initOperationsAdmin() {
    initOperationsNavigation();

    const roots = document.querySelectorAll('[data-operations-admin]');
    if (roots.length === 0) return;

    roots.forEach((root) => {
        initDialogs(root);
        initTabs(root);
        initDisclosure(root);
        initStaticForms(root);
    });
}
